module.exports = __webpack_public_path__ + "static/media/traceability.f20bfea3.svg";